export const palette = {
  primary: "#2E8BC0",     
  primarySoft: "#8FD3FE",   
  teal: "#2BB5A3",         
  sky: "#E6F5FF",          
  ink: "#0F1B2D",          
  muted: "#5E738A",   
  sky2: "#f7fcff",      
};

export const socialLinks = {
  whatsapp: "https://wa.me/5491156601095",
  instagram: "https://www.instagram.com/kalmares.ba/"
};


